import Button from '@components/Button';
import Row from '@components/Row';
import { InquiryResponse } from '@models/inquiry';
import { useFlow } from '@router/stackflow';

interface Props {
    inquiry: InquiryResponse;
}

function InquiryFooter({ inquiry }:Props) {
  const { push } = useFlow();
  const handleNewInquiry = () => {
    push('InquiryCommentBottomSheet', { inquiryId: inquiry.id });
  };
  const { status } = inquiry;
  return (
        <Row fullWidth spacing={8}>
            {status === 'ANSWERED' && (
                <Button fullWidth variant='secondary'
                        onClick={() => push('CloseInquiryModal', { inquiryId: inquiry.id })} >
                    문의 종료
                </Button>
            )}
            <Button fullWidth onClick={handleNewInquiry}
                    disabled={ status === 'CLOSED'} >
                추가 문의
            </Button>
        </Row>
  );
}

export default InquiryFooter;
